import { RegistrationOtpModel } from "../models/RegistrationOtpModel";
import { ResponseModel } from "../models/ResponseModel";
import { UserRegistrationModel } from "../models/UserRegistrationModel";
import { AjaxService } from "../shared/services/AjaxService";

const tempTokenOptions = (temporaryToken: string) => ({
    authToken: `Bearer ${temporaryToken}`,
    includeSessionAuth: false,
    clearSessionOnUnauthorized: false,
});

export const UserRegistrationService = {

    async getStates(): Promise<ResponseModel> {
        return AjaxService.get<ResponseModel>("/City/getState");
    },

    async getCitiesByState(stateId: string): Promise<ResponseModel> {
        return AjaxService.get<ResponseModel>(`/City/getCitiesAgainstState?stateId=${encodeURIComponent(stateId)}`);
    },

    async getMastersByTemple(templeId: string): Promise<ResponseModel> {
        return AjaxService.get<ResponseModel>(`/Master/getMastersAgainstTemple?templeId=${encodeURIComponent(templeId)}`);
    },

    async register(payload: UserRegistrationModel): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>("/User/userRegister", payload, {
            includeSessionAuth: false,
            clearSessionOnUnauthorized: false,
        });
    },

    async verifyOtp(payload: RegistrationOtpModel, temporaryToken: string): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>(
            "/User/registerOtpVerification",
            payload,
            tempTokenOptions(temporaryToken)
        );
    },

    async reverifyAccount(
        mobileNumber: string | null = null,
        email: string | null = null
    ): Promise<ResponseModel> {
        const params: string[] = [];

        if (mobileNumber) {
            params.push(`mobileNumber=${encodeURIComponent(mobileNumber)}`);
        }

        if (email) {
            params.push(`email=${encodeURIComponent(email)}`);
        }

        const query = params.length > 0 ? `?${params.join("&")}` : "";
        return AjaxService.get<ResponseModel>(`/User/reverifyAccount${query}`, {
            includeSessionAuth: false,
            clearSessionOnUnauthorized: false,
        });
    },

    async getEnumeration(code: string): Promise<ResponseModel> {
        return AjaxService.get<ResponseModel>(`/Enumeration/getEnumeration?code=${encodeURIComponent(code)}`);
    },

    async updateProfile(payload: any): Promise<ResponseModel> {
        return AjaxService.put<ResponseModel>("/User/update", payload);
    },

    async updateMobile(payload: any): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>("/User/registerOtpVerification", payload);
    },

    async deleteUser(payload: any): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>("/User/registerOtpVerification", payload);
    },

     async resendOtp(temporaryToken: string): Promise<ResponseModel> {
        return AjaxService.get<ResponseModel>("/User/resendOtp", tempTokenOptions(temporaryToken));
    },
}
